<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 123.103 48.845">
    <g id="Hatchback" transform="translate(10739.52 -174.42)">
      <path id="Path_87096" data-name="Path 87096"
        d="M42.811,403.442a10.051,10.051,0,1,0,10.051,10.051,10.063,10.063,0,0,0-10.051-10.051m0,17.763a7.711,7.711,0,1,1,7.712-7.712,7.72,7.72,0,0,1-7.712,7.712"
        transform="translate(-10678.712 -200.279)" :fill="themeColor" />
      <path id="Path_87097" data-name="Path 87097"
        d="M13.457,403.442h-.006A10.054,10.054,0,0,0,3.4,413.49a10.051,10.051,0,1,0,10.054-10.048m-.006,17.763a7.711,7.711,0,1,1,7.712-7.712,7.72,7.72,0,0,1-7.712,7.712"
        transform="translate(-10733.201 -200.279)" :fill="themeColor" />
      <path id="Path_87098" data-name="Path 87098"
        d="M19.772,410.928l76.354.38c1.608.437,3.23.806,4.821,1.094a45.405,45.405,0,0,1,13.285,4.162c3.8,2.656,5.927,11.085,6.541,15.184a1.171,1.171,0,1,0,2.316-.343c-.708-4.744-3.028-13.542-7.249-16.589a43.549,43.549,0,0,0-14.239-4.659A57.909,57.909,0,0,1,92.41,407.7c-1.891-.826-4.407-2.048-7.238-3.431a192.165,192.165,0,0,0-17.6-7.886c-16.269-5.716-46.775-1.6-50.2-1.114-8.977.2-12.525,14.835-13.145,17.766l-.211.5L.952,418.092a1.108,1.108,0,0,0-.18.437,21.465,21.465,0,0,0,.74,13.63,1.137,1.137,0,0,0,.84.583l.209,0a1.331,1.331,0,0,0,.477-.106,1.176,1.176,0,0,0,.568-1.56,18.752,18.752,0,0,1-.586-11.742l.191-.411L6.253,414.4a1.3,1.3,0,0,0,.183-.44c.029-.157,3.239-16.361,10.951-16.361,1.511-.206,33.156-4.733,49.468.986a180.669,180.669,0,0,1,16.881,7.575l5.584,2.739-69.554-.3a1.168,1.168,0,0,0,.006,2.336"
        transform="translate(-10739.52 -218.959)" :fill="themeColor" />
      <path id="Path_87099" data-name="Path 87099"
        d="M63.252,407.509a1.17,1.17,0,0,0-1.168-1.168h-48.2a1.167,1.167,0,1,0,0,2.333h48.2a1.169,1.169,0,0,0,1.168-1.165"
        transform="translate(-10715.914 -194.898)" :fill="themeColor" />
    </g>
  </svg>

</template>

<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
